import React, { useState } from "react";
import "./index.scss";

import contactImg from "../../../assets/images/contact.png"; // image à remplacer par la tienne
import { FlechBtn } from "../../../assets/icons/FlechBtn";
import { showErrorToaster } from "../../toaster/error";
import { showSuccessToaster } from "../../toaster/success";
import ContactService from "../../../services/contact/contact.service";
const contactService = new ContactService();
const ContactSection = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",

    message: "",
  });
  const [formErrors, setFormErrors] = useState();
  const [formation, setFormation] = useState([]);
  let label = {
    fullname: "Titre",
    email: "Email",

    message: "message",
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  console.log(formData);
  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = false;
    let errors = {};
    if (!formData?.fullname || formData?.fullname === "") {
      error = true;
      errors[`fullname`] = "Champ obligatoire";
    }
    if (!formData?.email || formData?.email === "") {
      error = true;
      errors[`email`] = "Champ obligatoire";
    }

    if (!formData?.message || formData?.message === "") {
      error = true;
      errors[`message`] = "Champ obligatoire";
    }

    setFormErrors(errors);
    if (error) {
      Object?.keys(errors)?.map((item) => {
        showErrorToaster(`${"champ"} ${label[item]} ${"est Obligatoire"} `);
      });
    } else {
      try {
        // Appeler la méthode du service pour ajouter la formation
        await contactService.addContact(formData);

        // Afficher le toast de succès
        showSuccessToaster("Inscription réussie au contact ");

        // Réinitialiser le champ et l'erreur
        setFormData({
          fullname: "",
          email: "",

          message: "",
        });
      } catch (error) {
        // Afficher le toast d'erreur
        showErrorToaster(
          error.response
            ? error.response.data.message
            : "Une erreur est survenue, veuillez réessayer."
        );
      }
    }
  };
  return (
    <section className="contact-section  py-5">
      <div className="row align-items-center">
        {/* Formulaire */}
        <div className="col-12 col-lg-6">
          <h2 className="contact-title">Contacter nous !</h2>
          <p className="contact-subtitle mt-3">
            Notre équipe est à votre écoute !
          </p>

          <form className="contact-form">
            <div className="mb-3">
              <label className="form-label">Nom</label>
              <input
                type="text"
                className="form-control"
                placeholder="Tapez votre nom"
                value={formData.fullname}
                onChange={handleChange}
                id="fullname"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Tapez votre email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Message</label>
              <textarea
                className="form-control"
                rows="3"
                id="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tapez votre message"></textarea>
            </div>

            <button type="submit" className="btn-submit" onClick={handleSubmit}>
              Envoyer <FlechBtn />
            </button>
          </form>
        </div>

        {/* Image */}
        <div className="col-12 col-lg-6 d-flex justify-content-center">
          <div className="contact-image-wrapper">
            <img src={contactImg} alt="Support" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
